import { createSlice } from "@reduxjs/toolkit";

const initialState = [];

const columnVisibilitySlice = createSlice({
    name: "column-filter",
    initialState,
    reducers: {
        setVisibleColumns: (_, action) => {
            return action.payload;
        },
    },
});

const { reducer, actions } = columnVisibilitySlice;

export const { setVisibleColumns } = actions;
export default reducer;
